<template>
  <div>
    <ToolbarAuth />
    <div class="mt-15 ml-15 mr-15">
      <v-card elevation="15" class="mb-15">
        <v-card-title class="primary--text">Noodplan BV </v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead></thead>
            <tbody>
              <tr>
                <td class="accent--text">Personalia</td>
                <td></td>
              </tr>
              <tr>
                <td>id</td>
                <td>{{ bv_planSingle.id }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.gender") }}</td>
                <td v-if="bv_planSingle.gender_client === '1'">Heer</td>
                <td v-if="bv_planSingle.gender_client === '2'">Mevrouw</td>
              </tr>
              <tr>
                <td>Voornaam</td>
                <td>{{ bv_planSingle.first_name_client }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.last_name") }}</td>
                <td>{{ bv_planSingle.last_name_client }}</td>
              </tr>
              <tr>
                <td>Adres</td>
                <td>{{ bv_planSingle.address_client }}</td>
              </tr>
              <tr>
                <td>Postcode</td>
                <td>{{ bv_planSingle.zip_client }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.place") }}</td>
                <td>{{ bv_planSingle.place_client }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ bv_planSingle.email_client }}</td>
              </tr>
              <tr>
                <td>{{ $t("users.telephone") }}</td>
                <td>{{ bv_planSingle.phone_number_client }}</td>
              </tr>
              <tr>
                <td class="accent--text">Bedrijf</td>
                <td></td>
              </tr>
              <tr>
                <td>Bedrijfsnaam</td>
                <td>{{ bv_planSingle.name_company }}</td>
              </tr>
              <tr>
                <td>Adres</td>
                <td>{{ bv_planSingle.address_company }}</td>
              </tr>
              <tr>
                <td>Postcode</td>
                <td>{{ bv_planSingle.zip_company }}</td>
              </tr>
              <tr>
                <td>Vestigingsplaats</td>
                <td>{{ bv_planSingle.place_company }}</td>
              </tr>
              <tr>
                <td class="accent--text">App</td>
                <td></td>
              </tr>
              <tr>
                <td>Kan de klant gebruik maken van de App</td>
                <td v-if="bv_planSingle.useApp === 'ke1'">Ja</td>
                <td v-if="bv_planSingle.useApp === 'ke2'">Nee</td>
              </tr>

              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Stijl e-mail uitnodiging</td>
                <td v-if="bv_planSingle.style === 'ke1'">Formeel</td>
                <td v-if="bv_planSingle.style === 'ke2'">Informeel</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Persoonlijke tekst e-mail uitnodiging</td>
                <td v-if="bv_planSingle.personalNote === 'ke1'">Ja</td>
                <td v-if="bv_planSingle.personalNote === 'ke2'">Nee</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Toegevoegde tekst</td>
                <td>{{ bv_planSingle.personalNoteText }}</td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Uitnodiging verzonden (e-mail)</td>
                <td v-if="bv_planSingle.invitation_send"><v-icon class="accent--text">mdi-check</v-icon></td>
                <td v-if="!bv_planSingle.invitation_send"><v-icon class="primary--text">mdi-minus-box</v-icon></td>
              </tr>
              <tr v-if="bv_planSingle.useApp === 'ke1'">
                <td>Datum uitnodiging verzonden (e-mail)</td>
                <td v-if="bv_planSingle.invitation_send">{{ bv_planSingle.date_invitation_send | myDate }}</td>
                <td v-if="!bv_planSingle.invitation_send">nog niet verzonden</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <div class="ml-16 align-center">
            <v-btn @click="sendInvitation()" x-large class="ma-16" color="info">Verstuur uitnodiging</v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" large class="ma-5" color="accent" :disabled="disableBtn"> {{ $t("crud.close") }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-spacer></v-spacer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import nplanBvService from "@/services/nplan/NplanBvService";
import { getError } from "@/utils/helpers";
export default {
  name: "bv-mail",
  components: { ToolbarAuth },
  data() {
    return {
      disableBtn: false,
    };
  },
  methods: {
    closeView() {
      this.$router.push({ name: "bvIndex" });
    },
    async sendInvitation() {
      let clientId = this.$route.params.id;
      this.disableBtn = true;
      await nplanBvService
        .sendInvitation(clientId)
        .then(() => {
          // eslint-disable-next-line no-undef
          EventBus.$emit("invSuc", true);
          this.$store.dispatch("bvSingle/getBVplan", clientId);
        })
        .then(() => {

          this.disableBtn = false;
        })
        .catch((error) => {
          // eslint-disable-next-line no-undef
          EventBus.$emit("invProblem", true);
          this.disableBtn = false;
          this.error = getError(error);
        });
    },
  },
  computed: {
    ...mapGetters("bvSingle", ["loading", "error", "bv_planSingle"]),
  },
  created() {
    let ClientId = this.$route.params.id;
    this.$store.dispatch("bvSingle/getBVplan", ClientId);
  },
};
</script>

<style scoped></style>
